import React from "react";
import "./main.css";

import StudentKomp from "./StudentKomp/StudentKomp";
import Cards from "./Cards";
import { HOST } from "./../config";

class LocalQuery extends React.Component {
  constructor(props) {
    super(props);
    // this.id = new URLSearchParams(window.location.search).get("id");
    // this.idg = new URLSearchParams(window.location.search).get("gid");
    // this.ws = new URLSearchParams(window.location.search).get("ws");
    this.id = localStorage.getItem("id");
    this.idg = localStorage.getItem("gid");
    this.ws = localStorage.getItem("ws");
    this.bk = localStorage.getItem("bk") == "true" ? true : false;

    this.state = {
      empty: false,
      YEAR: null,
      ORDERS: null,
      SCORE: null,
      PAYMENT: null,
      ORDERSfetch: true,
      SCOREfetch: true,
      PAYMENTfetch: this.bk,
    };
  }
  componentDidMount() {
    if (!this.id || !this.idg || isNaN(this.id) || isNaN(this.idg)) {
      this.setState({ empty: true });
    } else {
      fetch(`${HOST}/orders.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: this.id }),
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.ORDERS) {
            this.setState({
              ORDERS: json.ORDERS,
              ORDERSfetch: false,
            });
          } else {
            this.setState({
              ORDERS: null,
              ORDERSfetch: false,
            });
          }
        });
      fetch(`${HOST}/score.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: this.id, gid: this.idg }),
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.SCORE) {
            this.setState({
              SCORE: json.SCORE,
              SCOREfetch: false,
            });
          } else {
            this.setState({
              SCORE: null,
              SCOREfetch: false,
            });
          }
        });
      if (this.bk) {
        fetch(`${HOST}/payment.json`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: this.id }),
        })
          .then((res) => res.json())
          .then((json) => {
            if (json.PAYMENT && json.oplata.length && json.PAYMENT[0].length) {
              this.setState({
                PAYMENT: json.PAYMENT,
                PAYMENTfetch: false,
              });
            } else {
              this.setState({
                PAYMENT: null,
                PAYMENTfetch: false,
              });
            }
          });
      }
      fetch(`${HOST}/semester.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: this.id, gid: this.idg }),
      })
        .then((res) => res.json())
        .then((json) => {
          this.setState({
            SEMESTER: json,
            SEMESTERfetch: false,
          });
        });

      fetch(`${HOST}/year`)
        .then((res) => res.json())
        .then((json) => {
          this.setState({
            // YEAR: 18,
            YEAR: json.year,
          });
        });
    }
  }
  render() {
    if (this.state.empty) return <h1>Empty</h1>;

    if (
      this.state.PAYMENTfetch ||
      this.state.ORDERSfetch ||
      this.state.SCOREfetch ||
      this.state.SEMESTERfetch
    )
      return (
        <img className="loading-image" src="/lms/public/img/loading.gif" />
      );

    if (
      !this.state.ORDERSfetch &&
      !this.state.SCOREfetch &&
      !this.state.PAYMENTfetch &&
      !this.state.SEMESTERfetch
    )
      return (
        <div className="Desktop_main">
          <div className="Blue_container">
            <StudentKomp
              {...this.state}
              id_ws={this.ws}
              id_group={this.idg}
              id_student={this.id}
            />
            <Cards {...this.state} />
          </div>
        </div>
      );

    return <img className="loading-image" src="/lms/public/img/loading.gif" />;
  }
}

function Desktop() {
  return <LocalQuery />;
}

export default Desktop;
